import { COLUMN_DEFINITIONS } from './constants';

export const parseSearchValue = (val: string, validFields: string[]): { field: string; text: string } => {
    const array = val.split(/:(.*)/s);
    let field = '';
    let text = '';
    if (array.length > 1) {
        const idx = validFields.findIndex(item => item === array[0].trim());
        if (idx === -1) {
            field = '';
            text = val.trim();
        } else {
            field = array[0].trim();
            text = array[1].trim();
        }
    } else {
        field = '';
        text = val.trim();
    }
    return { field, text };
}

export function generateFilterChips(
  filters: {
    fieldName: string;
    value: string[];
    operation: string;
  }[],
  handleRemoveColumnFilter: (fieldName: string) => void
): { label: string; value: string; onDelete: () => void }[] {
  return filters?.flatMap((filter) => {
    const { fieldName, value } = filter;
    const columnConfig = COLUMN_DEFINITIONS.find(
      (column) => column.accessorKey === fieldName,
    );

    switch (fieldName) {
      case 'decision':
      case 'platforms':
      case 'states': {
        return [
          {
            label: columnConfig?.header ?? fieldName,
            value: `${value}`,
            onDelete: () => handleRemoveColumnFilter(fieldName),
          },
        ];
      }
      default:
        return [];
    }
  });
}